// extracted by mini-css-extract-plugin
export default {"container":"hero_container__k8pIo","background":"hero_background__Hh79f","content":"hero_content__7S9J0","profilePhoto":"hero_profilePhoto__a0t7i","about":"hero_about__Ch5CU"};